module.exports = __webpack_public_path__ + "static/media/ironentrance.5850ccac.mp3";